<template>
  <div class="products">
    <div class="nav">
      <div class="title-box">
        <h1 style="font-size: 35px; color: #2563af; margin-top: 30px;">PRODUCTS</h1>
        <YYTitle :yyMsg="yyMessage" class="hidden-xs-only"></YYTitle>
        <XSTitle :main="yyMessage" :sub="titEN" class="hidden-sm-and-up"></XSTitle>
      </div>

      <div 
        class="check" 
        @click="$router.push('/medical')"
        role="button"
        tabindex="0"
        @keydown.enter="$router.push('/medical')"
        aria-label="点击查看全部医影产品详情"
      >
        查看更多
        <svg t="1784189715529" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5404" width="200" height="200">
          <path d="M723.617792 522.446848 461.110272 239.74912 339.95264 239.74912 602.46016 522.446848 339.95264 784.945152l121.157632 0L723.617792 522.446848z" p-id="5405"></path>
        </svg>
      </div>

      <!-- 软件产品区块 -->
      <div class="product-block soft-block" ref="softBlock">
        <el-row class="grid-row" :gutter="30" type="flex" justify="center">
          <el-col v-for="(item, index) in pro_list" :key="index" :xs="24" :sm="12" :md="8" :ref="'softItem_' + index" class="product-item">
            <div 
              class="stepCard" 
              @click="toTab(item.name)"
              role="button"
              tabindex="0"
              @keydown.enter="toTab(item.name)"
              :aria-label="'查看产品：' + item.h5"
            >
              <div class="test">软件产品</div>
              <div class="card-img-wrap">
                <div 
                  class="card-img lazy" 
                  :data-src="bgList[index]"
                  :style="{ background: 'url(' + getPlaceholderImage(index) + ') no-repeat center' }"
                  :aria-label="item.h5 + '产品展示图'"
                  role="img"
                ></div>
                <div class="text">{{ item.h5 }}</div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 硬件产品区块 -->
      <div class="product-block hardware-block" ref="hardwareBlock">
        <el-row class="grid-row" :gutter="30" type="flex" justify="center">
          <el-col v-for="(item, index) in hardware" :key="index" :xs="24" :sm="12" :md="8" :ref="'hardwareItem_' + index" class="product-item">
            <div 
              class="stepCard" 
              @click="toTab(item.name)" 
              :class="`hard-card-${index}`"
              role="button"
              tabindex="0"
              @keydown.enter="toTab(item.name)"
              :aria-label="'查看产品：' + item.h5"
            >
              <div class="test">硬件产品</div>
              <div class="card-img-wrap">
                <div 
                  class="card-img lazy" 
                  :data-src="herdbgList[index]"
                  :style="{ backgroundImage: `url(${getPlaceholderImage(index)})` }"
                  :aria-label="item.h5 + '产品展示图'"
                  role="img"
                ></div>
                <div class="text">{{ item.h5 }}</div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import YYTitle from '../yyTitle.vue'
import XSTitle from '../eyTitXs.vue'
import MoreButton from './moreButton.vue'

export default {
  props: {
    bg: String
  },
  components: {
    YYTitle,
    XSTitle,
    MoreButton
  },
  data() {
    return {
      yyMessage: '医影产品',
      titEN: 'E-YING PRODUCTS',
      routeMap: {
        vr: '/medical',
        device: '/medical',
        performance: '/medical',
        pacs: '/medical',
        course: '/medical',
        hardware: '/medical',
        ct: '/medical',
        dr: '/medical',
        mri: '/medical'
      },
      pro_list: [
        { h5: '医学影像学导论', name: 'vr' },
        { h5: '医学影像设备学', name: 'device' },
        { h5: '医学影像检查技术学', name: 'performance' },
      ],
      hardware: [
        { h5: '实训设备', name: 'dr' },
        { h5: '实训设备', name: 'ct' },
        { h5: '实训设备', name: 'mri' },
      ],
      bgList: [
        require('@/assets/z1.png'),
        require('@/assets/z2.png'),
        require('@/assets/z3.png'),
        require('@/assets/z4.png'),
        require('@/assets/z5.png'),
        require('@/assets/z6.png'),
      ],
      phoneBgList: [
        require('@/assets/phone/z1.png'),
        require('@/assets/phone/z2.png'),
        require('@/assets/phone/z3.png'),
        require('@/assets/phone/z4.png'),
        require('@/assets/phone/z5.png'),
        require('@/assets/phone/z6.png'),
      ],
      herdList: [
        require('@/assets/z1.png'),
        require('@/assets/z2.png'),
        require('@/assets/z3.png'),
      ],
      herdbgList: [
        require('@/assets/image/6.png'),
        require('@/assets/image/4.png'),
        require('@/assets/image/5.png'),
      ],
      wWidth: window.innerWidth,
      observer: null,
      blockObserver: null,
      lazyObserver: null,
      placeholderImages: [
        'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100"%3E%3Crect width="100" height="100" fill="%23f0f2f5"/%3E%3C/svg%3E',
        'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100"%3E%3Crect width="100" height="100" fill="%23e8ecf1"/%3E%3C/svg%3E',
        'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100"%3E%3Crect width="100" height="100" fill="%23dfe4ea"/%3E%3C/svg%3E',
      ]
    }
  },
  mounted() {
    this.initIntersectionObserver()
    this.initLazyLoad()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeHandler)
    if (this.observer) this.observer.disconnect()
    if (this.blockObserver) this.blockObserver.disconnect()
    if (this.lazyObserver) this.lazyObserver.disconnect()
  },
  created() {
    window.addEventListener('resize', this.resizeHandler)
  },
  methods: {
    resizeHandler() {
      this.wWidth = window.innerWidth
    },
    getPlaceholderImage(index) {
      return this.placeholderImages[index % this.placeholderImages.length]
    },
    parentLink() {
      this.$router.push('/product')
      this.scrollTopZero()
      this.$store.commit('toTab/change_atN', 'vr')
    },
    scrollTopZero() {
      document.documentElement.scrollTop = document.body.scrollTop = window.pageYOffset = 0
    },
    toTab(name) {
      const targetPath = this.routeMap[name]
      if (!targetPath) return
      this.$router.push(targetPath)
      this.scrollTopZero()
    },
    initIntersectionObserver() {
      const blockOpt = { root: null, rootMargin: '0px 0px -80px 0px', threshold: 0.15 }
      this.blockObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('block-visible')
            const items = entry.target.querySelectorAll('.product-item')
            items.forEach((item, index) => setTimeout(() => item.classList.add('item-visible'), index * 120))
          }
        }, blockOpt)
      })
      const blocks = [this.$refs.softBlock, this.$refs.hardwareBlock]
      blocks.forEach(block => block && this.blockObserver.observe(block))

      const itemOpt = { root: null, rootMargin: '0px 0px -50px 0px', threshold: [0.1, 0.3, 0.5, 0.8] }
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => entry.isIntersecting && entry.target.classList.add('item-visible'))
      }, itemOpt)
      this.$nextTick(() => this.$el.querySelectorAll('.product-item').forEach(item => this.observer.observe(item)))
    },
    initLazyLoad() {
      this.lazyObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target
            const src = img.getAttribute('data-src')
            if (src) {
              requestAnimationFrame(() => {
                const preloadImg = new Image()
                preloadImg.onload = () => {
                  img.style.backgroundImage = `url(${src})`
                  img.classList.add('loaded')
                  img.removeAttribute('data-src')
                }
                preloadImg.onerror = () => img.classList.add('error')
                preloadImg.src = src
              })
              this.lazyObserver.unobserve(img)
            }
          }
        })
      }, { root: null, rootMargin: '0px 0px 100px 0px', threshold: 0.01 })
      this.$nextTick(() => this.$el.querySelectorAll('.lazy').forEach(img => this.lazyObserver.observe(img)))
    },
    refreshLazyLoad() {
      if (this.lazyObserver) this.$el.querySelectorAll('.lazy:not(.loaded)').forEach(img => this.lazyObserver.observe(img))
    }
  }
}
</script>

<style lang="scss" scoped>
$primary: #2563af;
$primary-light: #4a90d9;
$primary-fade: rgba(37, 99, 175, 0.12);
$primary-dark: #1a3a5c;
$gray-light: #f7fafe;
$gray-mid: #e8edf5;
$text-gray: #8fa8c8;
$shadow-base: 0 2px 12px rgba(37, 99, 175, 0.06);
$shadow-hover: 0 18px 48px rgba(37, 99, 175, 0.16), 0 6px 16px rgba(37, 99, 175, 0.07);

.products {
  margin: vw(20) 0 vw(80);
  width: 100%;
  border-radius: vw(24);
  padding-block: vw(40);

  .nav {
    width: 88%;
    margin: auto;
    border: 1px solid #ffffff;
    border-radius: 50px;
    background-color: #f7f9fc;
    padding: 0 7px;
  }

  // ===== 标题区域 =====
  .title-box {
    text-align: center;
    margin-bottom: vw(70);
    position: relative;

    &::after {
      content: "";
      width: vw(120);
      height: 3px;
      background: linear-gradient(90deg, transparent, $primary, transparent);
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: vw(-20);
      border-radius: 99px;
    }
  }

  // ===== 产品区块入场动画 =====
  .product-block {
    opacity: 0;
    transform: translateY(60px);
    transition: opacity 1s cubic-bezier(0.22, 1, 0.36, 1), transform 1s cubic-bezier(0.22, 1, 0.36, 1);
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;

    &.block-visible {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .check {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    width: 90px;
    padding: 10px 20px;
    margin-left: auto;
    margin-right: 50px;
    border-radius: 999px;
    color: #5a79a0;
    font-size: 15px;
    font-weight: 400;
    letter-spacing: 0.3px;
    cursor: pointer;
    background-color: #f7f9fc;
    border: 1px solid rgba(37, 99, 175, 0.12);
    transition: all 0.3s ease;

    &:hover {
      background-color: rgba(37, 99, 175, 0.14);
      color: $primary;
      border-color: rgba(37, 99, 175, 0.22);
      transform: translateY(-2px);
    }

    &:active {
      transform: translateY(0);
    }

    .icon {
      width: 18px;
      height: 18px;
      fill: currentColor;
      transition: transform 0.3s ease;
    }

    &:hover .icon {
      transform: translateX(3px);
    }
  }
  // ===== 卡片网格 =====
  .grid-row {
    flex-wrap: wrap;
    padding-bottom: vw(20);
    row-gap: vw(10);
    margin-top: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }

  // ===== 右上角分类标签 =====
  .test {
    position: absolute;
    top: 16px;
    right: 16px;
    z-index: 3;
    padding: 6px 18px;
    font-size: 14px;
    font-weight: 600;
    color: #ffffff;
    background: linear-gradient(135deg, $primary, $primary-light);
    border-radius: 20px;
    box-shadow: 0 2px 8px rgba(37, 99, 175, 0.25);
    line-height: 1.4;
    text-align: center;
    white-space: nowrap;
  }

  .product-item {
    opacity: 0;
    transform: translateY(40px) scale(0.94);
    transition: opacity 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94), transform 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    margin-bottom: vw(32);

    &.item-visible {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  // ===== 产品卡片主体 =====
  .stepCard {
    position: relative;
    height: vw(270);
    max-width: vw(400);
    margin: auto;
    background: #ffffff;
    box-shadow: $shadow-base;
    border: 1px solid rgba(37, 99, 175, 0.06);
    transition: transform 0.5s cubic-bezier(0.22, 1, 0.36, 1), box-shadow 0.5s ease;
    cursor: pointer;
    margin-bottom: 20px;
    overflow: hidden;
    border-radius: 12px;

    &:hover {
      transform: translateY(vw(-12)) scale(1.025);
      box-shadow: $shadow-hover;
      border-color: rgba(37, 99, 175, 0.12);

      .card-img-wrap .card-img {
        transform: scale(1.1);
      }

      .text {
        background: linear-gradient(0deg, rgba(26, 58, 92, 0.92) 0%, rgba(26, 58, 92, 0.4) 65%, transparent 100%);
      }
    }

    // 图片容器
    .card-img-wrap {
      position: relative;
      width: 100%;
      height: 100%;
      overflow: hidden;

      .card-img {
        width: 100%;
        height: 100%;
        background-size: 100% 95% !important;
        background-position: center !important;
        background-repeat: no-repeat !important;
        transition: transform 0.7s cubic-bezier(0.22, 1, 0.36, 1);
        will-change: transform;
        background-color: $gray-light;

        &.loaded {
          opacity: 1;
        }

        &.error {
          background: linear-gradient(135deg, #eaf0f8, $gray-mid) !important;
          position: relative;

          &::after {
            content: "图片加载失败";
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: $text-gray;
            font-size: vw(14);
          }
        }
      }

      // 底部产品名称渐变遮罩
      .text {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        padding: vw(20) vw(24);
        background: linear-gradient(0deg, rgba(26, 58, 92, 0.88) 0%, rgba(26, 58, 92, 0.35) 60%, transparent 100%);
        color: #fff;
        font-size: vw(20);
        font-weight: 600;
        letter-spacing: 1px;
        text-align: center;
        transition: background 0.5s ease;
        backdrop-filter: blur(3px);
        text-shadow: 0 3px 10px rgba(0, 0, 0, 0.25);
      }
    }

    // 硬件卡片独立底色区分
    &.hard-card-0 .card-img-wrap .card-img {
      background-color: #eaf4fc;
    }

    &.hard-card-1 .card-img-wrap .card-img {
      background-color: #f0f7ff;
    }

    &.hard-card-2 .card-img-wrap .card-img {
      background-color: #e6f0fb;
    }
  }

  // ===== 移动端 767px以下 =====
  @media only screen and (max-width: 767px) {
    margin-top: vp(40);
    padding: 0 vp(16);
    padding-block: vp(30);

    .title-box {
      margin-bottom: vp(45);

      &::after {
        width: vp(80);
        bottom: vp(-16);
      }
    }

    .stepCard {
      height: vp(210);
      max-width: 100%;
      border-radius: vp(16);

      .card-img-wrap .text {
        font-size: vp(16);
        padding: vp(14) vp(18);
      }

      &:hover {
        transform: translateY(vp(-8)) scale(1.015);
      }
    }

    .product-item {
      margin-bottom: vp(24);
    }

    .product-block {
      margin-bottom: vp(60);
    }

    .grid-row {
      padding-bottom: 0;
    }
  }

  // ===== 平板端 768~1024 =====
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    .stepCard {
      height: vw(230);
    }
  }

  // ===== 卡片依次延迟入场动画 =====
  @for $i from 1 through 10 {
    .product-item:nth-child(#{$i}) {
      transition-delay: #{$i * 0.06}s;
    }
  }
}
</style>